<template>
  <div class="teacherManger">
    <el-card style="margin-bottom:10px;">
      <el-row :gutter="24">
        <el-col :sm="12" :md="12" :lg="12" style="display:flex">
          <img :src="infoObj.img" alt="" style="width:300px;height:200px;">
          <span>{{infoObj.name}}</span>
        </el-col>
        <el-col :sm="12" :md="12" :lg="12" style="display:flex">
          <el-row :gutter="24">
            <el-col :sm="12" :md="12" :lg="12">
              <div class="cw250">总阅读数：{{infoObj.todayViewNum}}</div>
              <div class="cw250">总点赞数：{{infoObj.todayLikeNum}}</div>
              <div class="cw250">总收藏数：{{infoObj.todayCollectNum}}</div>
            </el-col>
            <el-col :sm="12" :md="12" :lg="12">
              <div class="cw250">今日阅读数：{{infoObj.sumViewNum}}</div>
              <div class="cw250">今日点赞数：{{infoObj.sumLikeNum}}</div>
              <div class="cw250">今日收藏数：{{infoObj.sumCollectNum}}</div>
            </el-col>
            <!-- <el-col :sm="12" :md="5" :lg="5" style="float:right">
          <el-button 
            type="primary"
            style="float:right"
            @click="showAddDialog = true;getSubjectTreeList()"
            icon="el-icon-plus"
          >添加教师</el-button>
        </el-col> -->
          </el-row>
        </el-col>
        <!-- <el-col :sm="12" :md="5" :lg="5" style="float:right">
          <el-button 
            type="primary"
            style="float:right"
            @click="showAddDialog = true;getSubjectTreeList()"
            icon="el-icon-plus"
          >添加教师</el-button>
        </el-col> -->
      </el-row>
    </el-card>
    <el-card>
      <el-row :gutter="20" style="margin-bottom:10px;">
        <el-col :sm="12" :md="10" :lg="10" style="display:flex">
          <el-input type="text" v-model="searchForm.name" placeholder="姓名/手机号"></el-input>
          <el-button type="primary" @click="currentPage=1,getPageList()" icon="el-icon-search">查询</el-button>
          <el-button type="primary" @click="currentPage=1,getPageList()">导出</el-button>
        </el-col>
        <!-- <el-col :sm="12" :md="5" :lg="5" style="float:right">
          <el-button 
            type="primary"
            style="float:right"
            @click="showAddDialog = true;getSubjectTreeList()"
            icon="el-icon-plus"
          >添加教师</el-button>
        </el-col> -->
      </el-row>
      <el-row>

      </el-row>
    </el-card>
    <el-card class="box-card">
      <el-table v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" class="teacherTable" :data="tableData" border style="width: 100%;margin-top:20px;" prop="date">
        <!-- <el-table-column type="index" :index="indexMethod" label="排序" width="50"></el-table-column> -->
        <el-table-column prop="account" show-overflow-tooltip label="手机号"></el-table-column>
        <el-table-column prop="name" show-overflow-tooltip label="姓名"></el-table-column>
        <el-table-column prop="businessType" show-overflow-tooltip label="用户行为">
          <template slot-scope="scope">
            {{scope.row.businessType=='viewNum'?'阅读':(scope.row.businessType=='likeNum'?'点赞':'收藏')}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="时间" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="initCollectNum" label="停留时长" :show-overflow-tooltip="true"> </el-table-column>
      </el-table>
      <div class="table_bottom">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" style="margin-top: 20px;text-align: left;" background layout="prev, pager, next, jumper,  total, sizes" :total="total" :page-size.sync="pageSize" :current-page.sync="currentPage"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cmVisible: false,
      dialogVisible: false,
      ClassInfoTreeList: [],
      classOptions: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name"
      },
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeList: [],
      treeData: [], //校区树
      propsxxx: {
        children: "children",
        label: "name"
      },
      tableData: [], //表格数据
      searchForm: {
        tableType: '',
        sell: '',
        name: '',
      },
      createTime: '',
      showAddDialog: false,
      showEditorDialog: false,
      addwidth: "60%",
      loading: false,
      campusId: "",
      searchCampusId: null,
      form: {
        campusId: null,
        account: "",
        name: "",
        headPic: "",
        enabled: 1,
        remark: "",
        detail: ""
      },
      editForm: [],
      id: "",
      pageSize: 10,
      currentPage: 1,
      total: 0, //总的数据数
      start: "",
      end: "",
      pageNumber: [
        {
          value: 10,
          label: 10
        },
        {
          value: 20,
          label: 20
        }
      ],
      clickData: {},
      infoObj: {},
    };
  },
  components: {
  },
  created () {
    this.getPageList();
    this.getInfo()
  },
  methods: {
    getInfo () {
      this.api.classInfo.getCommonDataStatistics({ id: this.$route.query.id }).then(res => {
        this.infoObj = res.data
      })
    },
    indexMethod (index) {
      return index + 1 + (this.currentPage - 1) * 10;
    },
    handleRemove (file, fileList) {
      // this.uploadList = fileList;
      // if (this.picUrl.length > 0) {
      //   for (let i = 0; i < this.picUrl.length; i++) {
      //     if (this.picUrl[i].uid == file.uid) {
      //       this.picUrl.splice(i, 1);
      //     }
      //   }
      // }
    },
    handleChange (file, fileList) {
      // this.picUrl = fileList.slice(-1);
    },
    beforeUpload (file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    UploadSuccess (res, file, fileList, val) {
      if (this.showEditorDialog) {
        this.form.headPic = res.data;
        console.log("22222", this.form.headPic);
      } else if (this.showAddDialog) {
        this.form.headPic = res.data;
        console.log("233333333", this.form.headPic);
      }
      // this.picUrl.push({
      //   name: res.data[0].FileName,
      //   url: res.data[0].FilePath
      // });
    },
    sizeChange () {
      this.pageChange();
    },
    currentChange () {
      this.pageChange();
    },
    pageChange () {
      // //分页发生变化时
      // let data;
      // if (this.inp && !this.campusId) {
      //   data = {
      //     pageNumber: this.currentPage,
      //     pageSize: this.pageSize,
      //   };
      // } else {
      //   data = {
      //     pageNumber: this.currentPage,
      //     pageSize: this.pageSize,
      //   };
      // }
      // this.api.agentUserInfo.teacherPageList(data).then(result => {
      //   if (result.success) {
      //     this.loading = false;
      //     this.tableData = result.data.records;
      //   }
      // });
      this.getPageList()
    },
    paginationInit () {
      if (this.currentPage == 1 && this.total <= this.pageSize) {
        this.start = 1;
        this.end = this.total;
      } else if (this.currentPage * this.pageSize < this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.currentPage * this.pageSize;
      } else if (this.currentPage * this.pageSize >= this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.total;
      }
      console.log(this.start, this.end);
    },
    getPageList () {
      let data = {
        tableId: this.$route.query.tableId,
        name: this.searchForm.nameOrMobile,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      this.loading = true;
      // console.log(data)
      this.api.classInfo.getUserActionLog(data).then(result => {
        if (result.success) {
          this.tableData = result.data.records;
          for (let item of this.tableData) {
            item.enabled = String(item.enabled);
          }
          this.total = Number(result.data.total);
          this.paginationInit();
          this.loading = false;
        }
      });
    },

    // 重置
    resetaddForm () {
      this.$refs.addForm.resetFields();
    },

    clearForm () {
      this.form = {
        campusId: null,
        account: "",
        name: "",
        headPic: "",
        enabled: 1,
        remark: "",
        detail: ""
      };
    }
  },

};
</script>

<style scoped>
.teacherManger {
}

.teacherManger .el-radio {
  margin-right: 10px;
}
.el-input--suffix .el-input__inner {
  padding-right: 20px;
}

.sidebar,
.sidebarRight {
  background: white;
  padding: 0 20px 20px 0;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.teacherManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}

.addDialog .el-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}

.addDialog .dialogLeft {
  text-align: right;
  padding-right: 10px;
}

.addDialog .el-dialog__body {
  padding: 15px 20px !important;
}

.table_bottom {
  margin: 20px 0;
}
.upload-img {
  width: 80px;
  height: 80px;
}
.plan-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
}
</style>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}
.upload-div {
  display: flex;
  flex-direction: row;
  .upload-img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid rgb(238, 238, 238);
  }
  .upload-content {
    margin-left: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content-text {
      width: 80px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
    }
    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
    }
  }
}
.cw250 {
  width: 250px;
}
</style>


// WEBPACK FOOTER //
// src/components/conmom/courseDataStatistic.vue